import React from 'react'
import { AllUserReportLayerList } from '../components/Report/AllUserReportLayerList'
import MasterLayout from '../masterLayout/MasterLayout'

export const AllUserReportPageList = () => {
  return (
    <MasterLayout>
    
    <AllUserReportLayerList/>
    </MasterLayout>
  )
}
